function fetchFallback() {
    return import(
        /* webpackChunkName: "locales" */
        /* webpackPreload: true */
        '../../locales/en_US.json'
    );
}

export default fetchFallback;
